export default __webpack_public_path__ + "static/gero1-82068380c48e7075ade4aab6f0293f49.jpg";